import { ReactElement } from "react";
import { Outlet, Navigate } from "react-router-dom";
import AuthService from "../api/services/AuthService";
import { LOGIN } from "./paths";

// This is a wrapper to protect routes that require authentication
const PrivateRoute = ({
  redirectPath = LOGIN,
  children,
}: {
  redirectPath?: string;
  children?: ReactElement;
}) => {
  if (!AuthService.isAuthenticated()) {
    return <Navigate to={`/${redirectPath}`} replace />;
  }

  return children ? children : <Outlet />;
};

export default PrivateRoute;
